/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Filter_Possible_DuplicateInputs */

const vi_expense_filter_possible_duplicate = /** @type {(inputs: Expense_Filter_Possible_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có thể trùng`)
};

/**

* @param {Expense_Filter_Possible_DuplicateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_filter_possible_duplicate = /** @type {((inputs?: Expense_Filter_Possible_DuplicateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Filter_Possible_DuplicateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_filter_possible_duplicate(inputs)
});